import { DEFAULT_PARAMS, objectsRHandler } from '@/utils/objectsRHandler';
import Group from '../list/group';
import GroupAge from '../list/group-age';
import { rHandler } from '@/plugins/RHandler';
import { apiService } from '@/services/APIService';
import { DELETION_PROCESS_TYPE } from '../list/event-deletion-process';
import { deletionProcesses } from './deletion-processes';

const API_PATH = 'event-groups';
const API_PATH_AGES = 'event-group-ages';
const API_PATH_GLOBAL = 'global-event-groups';

export const GroupManager = {
  deletion: {
    ...deletionProcesses(DELETION_PROCESS_TYPE.group),
    preview({ args = [], params } = DEFAULT_PARAMS) {
      const [id] = args;
      return rHandler(
        apiService.get(`${API_PATH}/${id}/deletion-preview`, params),
        (response) => ({ response, preview: response.data.data }),
        (error) => ({ error }),
      );
    },
    start({ args = [], data = {} } = DEFAULT_PARAMS) {
      const [id] = args;
      return rHandler(
        apiService.delete(`${API_PATH}/${id}/with-transfer`, { data }),
        (response) => ({ response, processId: response.data.data.deletion_process_id }),
        (error) => ({ error }),
      );
    },
  },
  objects: {
    ...objectsRHandler(API_PATH, Group),
    bulkCreate({ data, obs } = DEFAULT_PARAMS) {
      return rHandler(
        apiService.post(`${API_PATH}/bulk`, data),
        (response) => ({
          response,
          items: response.data.data.map((group) => new Group(group, API_PATH)),
        }),
        (error) => ({ error }),
        obs,
      );
    },
    nominationAttach({ args = [], data } = DEFAULT_PARAMS) { // { groups: Number[] }
      const [nomination_id] = args;
      return rHandler(
        apiService.put(`/event-nominations/${nomination_id}/groups`, data),
        (response) => ({ response }),
        (error) => ({ error }),
      );
    },
    nominationDetach({ args = [], data } = DEFAULT_PARAMS) { // { groups: Number[] }
      const [nomination_id] = args;
      return rHandler(
        apiService.delete(`/event-nominations/${nomination_id}/groups`, data),
        (response) => ({ response }),
        (error) => ({ error }),
      );
    },
  },
  ages: objectsRHandler(API_PATH_AGES, GroupAge),
  global: {
    index({ params, obs } = DEFAULT_PARAMS) {
      return rHandler(
        apiService.getCached(API_PATH_GLOBAL, params),
        (response) => ({
          response,
          items: response.data.data.map((i) => new Group(i, API_PATH_GLOBAL)),
        }),
        (error) => ({ error }),
        obs,
      );
    },
  },
};
